import { get, post, upload } from '../../utils/api'
import { AxiosResponse } from 'axios'

export const fetchThemes = (courseId: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${courseId}/themes`)

export const fetchModules = (id: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/modules`, {
    include: 'lessons,lessonsCount,lessons.userLesson,moduleScreens',
  })

export const createLesson = (
  id: string,
  title: string,
  icon: File,
  theme: string
): Promise<AxiosResponse> =>
  upload(
    '/courses/lessons',
    {
      item: icon,
      field: 'file',
    },
    {
      course_id: id,
      title,
      theme_id: theme,
    }
  )

export const connectModuleLesson = (
  mid: string,
  lid: string,
  indexNumber: number,
  timeToStudy: number,
  assistantCaption: string,
  isFirst: string,
  isLast: string,
  isFree: string,
  availableAt: string,
  position: number
): Promise<AxiosResponse> =>
  post('/courses/module-lessons', {
    module_id: mid,
    lesson_id: lid,
    index_number: indexNumber,
    time_to_study: timeToStudy,
    assistant_caption: assistantCaption,
    is_first: isFirst,
    is_last: isLast,
    is_free: isFree,
    available_at: availableAt,
    position,
  })
